/// <reference path="../../Data/List/FormatLookupEditor.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerEditor("Matrix.Data.SecurityPicker")
    export class SecurityPicker extends FormatLookupPickerBase<FormatLookupEditorOptions, SecurityRow>  {

        constructor(hidden: JQuery, options: FormatLookupEditorOptions) {
            super(hidden, options);
    
        }

        handleEditClick() {
            var dlg = new SecurityPickerDialog();
            dlg.criteria = this.getFilterCriteria();
            dlg.allowClear = true;
            dlg.value = this.values;
            dlg.dialogOpen();
            dlg.onSuccess = sel => {
                this.values = dlg.value;
                return true;
            }
        }

        protected displayName() {
            return "securities";
        }

        protected getLookupKey() {
            return SecurityRow.lookupKey;
        }
    }
}